import { render, staticRenderFns } from "./expertExtractionFrom.vue?vue&type=template&id=9c0a173a&scoped=true"
import script from "./expertExtractionFrom.vue?vue&type=script&lang=js"
export * from "./expertExtractionFrom.vue?vue&type=script&lang=js"
import style0 from "./expertExtractionFrom.vue?vue&type=style&index=0&id=9c0a173a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0a173a",
  null
  
)

export default component.exports